import API_ENDPOINTS from './apiConfig';
import type { TrackingData } from '../types';

export interface TrackShipmentResult {
  success: boolean;
  data?: TrackingData;
  error?: string;
}

export const trackShipmentByAwb = async (
  awbCode: string,
  token: string | null
): Promise<TrackShipmentResult> => {
  try {
    const response = await fetch(`${API_ENDPOINTS.TRACKBYAWB}${awbCode}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (response.ok) {
      return { success: true, data };
    }
    return { success: false, error: data.error || 'Failed to track shipment' };
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    return { success: false, error: 'Network error: ' + message };
  }
};
